import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, tap, throwError } from "rxjs";
import { CompanyHelper, PlansModalBridgeService } from "../../../public-api";
import { CONSTANTS, Constants } from "../../commons/injection.token";
import { AuthenticationService } from "../../services/authentication.service";
import { AlertService } from "../components/alert/alert.service";

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {

  private constants: Constants;

  constructor(
    injector: Injector,
    private alertService: AlertService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private plansModalBridge: PlansModalBridgeService
  ) {
    this.constants = injector.get(CONSTANTS);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: () => {
          if (localStorage.getItem(this.constants['currentUser'])) {
            const currentUser = JSON.parse(localStorage.getItem(this.constants['currentUser']))?.user;
            if (currentUser) {
              const currentCompany = currentUser?.company;
              const trialActivated = currentCompany?.trial?.activated === true;
              if (trialActivated) {
                const calculateTrialDays = CompanyHelper.calculateTrialDays(currentCompany.trial.startDate, currentCompany.trial.durationDays);
                const trialExpired = calculateTrialDays.expired === true;
                if (trialExpired) {
                  this.plansModalBridge.requestOpen({ reason: 'payment_required' });
                }
              }
            }
          }
          return true;
        },
        error: (err: HttpErrorResponse) => {

          let dsError = "";
          switch (err?.status) {
            case 0:
              // dsError = "Falha de comunicação com o servidor.";
              dsError = undefined; // "Falha de comunicação com o servidor.";
              break;

            case 400:
              dsError = err.error.message;
              break;

            case 401:
              dsError = "Usuário não possui permissão de acesso.";
              this.authenticationService.logout();
              window.location.href = '/login';
              break;

            case 402:
              // The wallet refused a send or a dispatch for lack of balance. The API
              // answers with the reason already in the user's language, so it is shown
              // as it came: a generic failure would hide the one thing the person can
              // act on. Screens that show `err.error.message` themselves do not end up
              // with two toasts — the applications registering this interceptor run
              // ngx-toastr with `preventDuplicates`, which drops a second toast
              // carrying the same text.
              dsError = err.error?.message;
              break;

            case 403:
              dsError = err.error.message;
              this.authenticationService.logout();
              window.location.href = '/login';
              break;

            case 500:
              dsError = err.error.message;
              break;
          }

          if (!!dsError) {
            this.alertService.error(dsError);
          }

          return throwError(() => new Error(dsError));
        }
      })
    );
  }
}
